interface Outcome {
  imageUrl: string;
  label: string;
  description: string;
}

interface OutcomesBlockProps {
  content: {
    title?: string;
    outcomes?: Outcome[];
    showDivider?: boolean;
  };
}

export function OutcomesBlock({ content }: OutcomesBlockProps) {
  if (!content.outcomes?.length) return null;

  return (
    <section className="mx-auto max-w-[1200px] px-6 py-20">
      {content.showDivider && <div className="mb-12 h-px w-16 bg-border" />}
      {content.title && (
        <h2 className="font-serif text-2xl md:text-3xl text-foreground mb-12">
          {content.title}
        </h2>
      )}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {content.outcomes.map((outcome, i) => (
          <div key={i} className="group">
            <div className="aspect-[4/3] overflow-hidden mb-4">
              <img
                src={outcome.imageUrl}
                alt={outcome.label}
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.02]"
              />
            </div>
            <p className="font-sans text-sm text-foreground">
              <strong>{outcome.label}:</strong>{" "}
              <span className="text-muted-foreground">{outcome.description}</span>
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
